module.exports = function() {
  return new Worker(__webpack_public_path__ + "7fbeac1cd638e95d4269.worker.js");
};